import { render, staticRenderFns } from "./messager.vue?vue&type=template&id=40d8a6d9&"
import script from "./messager.vue?vue&type=script&lang=js&"
export * from "./messager.vue?vue&type=script&lang=js&"
import style0 from "./messager.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports